<!--
 * @Author: wsx
 * @Date: 2022-01-05 18:45:47
 * @LastEditTime: 2023-01-10 16:32:06
 * @LastEditors: zhaoshuai 894028693@qq.com
 * @Description:车牌号选择
-->
<template>
  <el-form
    ref="ruleFormRef"
    :model="plateNoForm"
    :rules="rules"
    class="HCarPlateNoSelect"
    :inline="true"
  >
    <el-form-item :label="label" prop="regionId">
      <el-select
        v-model="plateNoForm.plateColor"
        placeholder="不限"
        @change="colorChange"
      >
        <el-option
          v-for="item in colorList"
          :key="item.code"
          :label="item.value"
          :value="item.code"
        >
          <div class="colorItem">
            <div
              class="carColor"
              :style="{ backgroundColor: item.remark }"
            ></div>
            <span>{{ item.value }}</span>
          </div>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-select
        v-model="plateNoForm.ownershipCode"
        placeholder="不限"
        @change="ownershipChange"
      >
        <el-option
          v-for="item in ownershipList"
          :key="item.code"
          :label="item.value"
          :value="item.code"
        >
          <div class="owerShipClass">
            <div class="owerShipItemClass">{{ item.value }}</div>
          </div>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-popover
        :width="260"
        trigger="click"
        placement="bottom-start"
        content="'*'通配符，代表0位或者多位，'?'为占位符，匹配一位"
      >
        <template #reference>
          <el-input
            v-model.trim="plateNoForm.plateNo"
            placeholder="车牌号"
          ></el-input>
        </template>
      </el-popover>
    </el-form-item>
  </el-form>
</template>
<script>
import {
  computed,
  defineComponent,
  reactive,
  toRefs,
  watch,
  watchEffect
} from "vue";
import { getDict } from "@/api/constant";
export default defineComponent({
  name: "HCarPlateNoSelect",
  components: {},
  props: {
    plateInfo: {
      type: Object,
      default: () => {}
    },
    plateColor: {
      type: Object,
      default: ""
    },
    plateNo: {
      type: String,
      default: ""
    },

    label: {
      type: String,
      default: "车牌号码"
    }
  },
  setup(props, { emit }) {
    const data = reactive({
      plateName: "",
      plateNoForm: {
        plateNo: "", // 车牌号
        ownership: "", // 归属地name
        ownershipCode: "", // 归属地code
        plateColor: "", // 车牌颜色code
        plateColorName: "" // 车牌颜色名
      },
      colorList: [], // 车牌颜色
      ownershipList: [], // 车牌归属地
      rules: {
        plateNo: [
          {
            required: true,
            message: "请输入车牌号",
            trigger: "blur"
          }
        ]
      }
    });
    // 获取数据字典
    const queryMenuType = async () => {
      const resCarColor = await getDict("car_card_color");
      const resOwnership = await getDict("plate_ownership");
      data.colorList = resCarColor.dict;
      data.ownershipList = resOwnership.dict;
      data.colorList.unshift({ value: "不限", code: "" });
      data.ownershipList.unshift({ value: "不限", code: "" });
    };
    queryMenuType();
    watchEffect(() => {
      if (props.plateColor) data.plateNoForm.plateColor = props.plateColor;
      data.plateNoForm.plateNo = props.plateNo;
      console.log(props.plateNo);
      if (props.plateNo == "") {
        data.plateNoForm.ownershipCode = "";
        data.plateNoForm.ownership = "";
      }
    });
    watchEffect(async() => {
      if (data.plateNoForm.plateNo) {
        if (data.ownershipList.length == 0) await queryMenuType();
        const len = data.plateNoForm.plateNo.split("");
        if (len.length > 7) {
          data.plateNoForm.plateNo = data.plateNoForm.plateNo.substring(0, 6);
        }
        const first = data.plateNoForm.plateNo.split("");
        const reg =
          /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]$/;
        console.log(first);
        console.log(data.ownershipList);
        if (reg.test(first[0])) {
          data.plateNoForm.ownership = first[0];
          data.plateNoForm.ownershipCode = data.ownershipList.find(
            (item) => item.value == first[0]
          ).code;
          data.plateNoForm.plateNo = data.plateNoForm.plateNo.substring(
            1,
            first.length
          );
        }
      }
    });
    watch(
      () => data.plateNoForm,
      () => {
        emit("update:plateInfo", data.plateNoForm);
        emit("update:plateColor", data.plateNoForm.plateColor);
        emit(
          "update:plateNo",
          data.plateNoForm.ownership + data.plateNoForm.plateNo
        );
      },
      {
        deep: true
      }
    );

    const colorChange = (val) => {
      data.plateNoForm.plateColorName = data.colorList.find(
        (item) => item.code == val
      ).value;
      if (data.plateNoForm.plateColorName == "不限") {
        data.plateNoForm.plateColorName = "";
      }
    };
    const ownershipChange = (val) => {
      data.plateNoForm.ownership = data.ownershipList.find(
        (item) => item.code == val
      ).value;
      if (data.plateNoForm.ownership == "不限") {
        data.plateNoForm.ownership = "";
      }
    };

    const refData = toRefs(data);
    return { ...refData, ownershipChange, colorChange };
  }
});
</script>
<style lang="scss" scoped>
.HCarPlateNoSelect {
  position: relative;
  .el-form-item {
    margin-right: 0px;
    /deep/.el-input__inner {
      border-radius: 0px;
    }
  }
  .el-select {
    width: 100px;
  }
  .el-input {
    width: 100px;
  }
  .el-btn {
    width: 100px;
    height: 32px;
    font-size: 14px;
    color: #ccc4cc;
    border: 1px solid #dcdfe6;
    @include flex-row-sb-c;
    padding: 0 10px;
  }
}
.colorItem {
  @include flex-row-sb-c;
  .carColor {
    width: 16px;
    height: 16px;
  }
}
</style>
